module.exports = __webpack_public_path__ + "static/media/cars.9c56153e.jpg";